import { combineReducers } from 'redux';
import { createResponsiveStateReducer } from 'redux-responsive';

import { reducer as oidcReducer } from 'redux-oidc';
import BREAKPOINTS from '../data/breakpoints';
import backendSyncReducer from './completeReducers/backendSync';
import { closeTabReducer } from './completeReducers/windowmanagement';
import backEnd from './partialReducers/backEnd';
import breakNames from './partialReducers/breakNames';
import chat from './partialReducers/chat';
import customers from './partialReducers/customers';
import environment from './partialReducers/environment';
import login from './partialReducers/login';
import messages from './partialReducers/messages';
import notifications from './partialReducers/notifications';
import panel from './partialReducers/panel';
import panelSet from './partialReducers/panelSet';
import scripting from './partialReducers/scripting';
import uiState from './partialReducers/uiState';
import user from './partialReducers/user';

const appReducer = combineReducers({
  panel,
  panelSet,
  user,
  login,
  uiState,
  backEnd,
  breakNames,
  notifications,
  environment,
  scripting,
  chat,
  customers,
  messages,
  oidc: oidcReducer,
  browser: createResponsiveStateReducer(
    BREAKPOINTS,
    {
      extraFields: () => ({
        width: window.innerWidth,
        height: window.innerHeight
      })
    }
  )
});

const rootReducer = (state, action) => {

  // NOTE: action name is hardcoded; keep the action name in synch here!!!
  if (action.type.includes("Store state data retrieved from the back-end")) {
    return backendSyncReducer(state, action);
  }

  if (action.type.includes("Close tab")) {
    return closeTabReducer(state, action);
  }


  return appReducer(state, action);
};

export default rootReducer;
